(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flux-account"]) return;
  try {
    
(function(){
  document.querySelectorAll('[data-fxa-eye]').forEach(function(b){b.addEventListener('click',function(){var i=b.parentNode.querySelector('input');var s=i.type==='password';i.type=s?'text':'password';b.textContent=s?'Hide':'Show';});});
  var login=document.querySelector('[data-fxa-login]'),rec=document.querySelector('[data-fxa-recover]');
  function showRec(v){if(!login||!rec)return;login.hidden=v;rec.hidden=!v;}
  document.querySelectorAll('[data-fxa-show-recover]').forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();showRec(true);});});
  document.querySelectorAll('[data-fxa-show-login]').forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();showRec(false);});});
  if(document.querySelector('[data-fxa-recover-open]')||location.hash==='#recover')showRec(true);
  document.querySelectorAll('[data-fxa-toggle]').forEach(function(b){b.addEventListener('click',function(){var el=document.getElementById(b.getAttribute('data-fxa-toggle'));if(el)el.hidden=!el.hidden;});});
  document.querySelectorAll('[data-fxa-del]').forEach(function(b){b.addEventListener('click',function(){
    if(!b.getAttribute('data-arm')){b.setAttribute('data-arm','1');b.textContent='Tap again to confirm';setTimeout(function(){b.removeAttribute('data-arm');b.textContent='Delete';},4000);}
    else{b.form.submit();}
  });});
  document.querySelectorAll('[data-fxa-country]').forEach(function(cs){
    var form=cs.closest('form');var ps=form.querySelector('[data-fxa-province]');var pw=ps.closest('.fxa__f');
    var defC=cs.getAttribute('data-default')||'United Kingdom',defP=ps.getAttribute('data-default')||'';
    for(var i=0;i<cs.options.length;i++){if(cs.options[i].value===defC||cs.options[i].text===defC){cs.selectedIndex=i;break;}}
    function fill(){
      var opt=cs.options[cs.selectedIndex],prov=[];
      try{prov=JSON.parse(opt.getAttribute('data-provinces')||'[]');}catch(e){}
      ps.innerHTML='';
      if(!prov.length){pw.hidden=true;return;}
      pw.hidden=false;
      prov.forEach(function(p){var o=document.createElement('option');o.value=p[0];o.textContent=p[1];if(p[0]===defP||p[1]===defP)o.selected=true;ps.appendChild(o);});
    }
    cs.addEventListener('change',function(){defP='';fill();});
    fill();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flux-cart-keeper"]) return;
  try {
    
(function(){
  var K='fx_cart_snap',TTL=30*24*60*60*1000;
  function load(){try{return JSON.parse(localStorage.getItem(K)||'null');}catch(e){return null;}}
  function save(s){try{localStorage.setItem(K,JSON.stringify(s));}catch(e){}}
  function clear(){try{localStorage.removeItem(K);}catch(e){}}
  document.addEventListener('click',function(e){
    var t=e.target.closest&&e.target.closest("a[href*='/checkout'],button[name='checkout']");
    if(t){var s=load();if(s){s.checkout=true;save(s);}}
  },true);
  fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(c){
    var s=load();
    if(s&&Date.now()-s.ts>TTL){clear();s=null;}
    if(c.item_count>0){
      var sig=c.items.map(function(i){return i.variant_id+'x'+i.quantity;}).join(',');
      var ts=(s&&s.sig===sig)?s.ts:Date.now();
      save({token:c.token,sig:sig,ts:ts,checkout:false,items:c.items.map(function(i){return {id:i.variant_id,quantity:i.quantity,properties:i.properties||undefined};})});
    }else if(s){
      if(s.token!==c.token&&!s.checkout&&s.items&&s.items.length&&!sessionStorage.getItem('fx_cart_restored')){
        try{sessionStorage.setItem('fx_cart_restored','1');}catch(e){}
        var chain=Promise.resolve();
        s.items.forEach(function(it){chain=chain.then(function(){return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[it]})}).catch(function(){});});});
        chain.then(function(){window.location.reload();});
      }else{clear();}
    }
  }).catch(function(){});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flux-cart-recs"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-fxr]').forEach(function(el){
    var pid=el.getAttribute('data-product');
    if(!pid)return;
    var url=el.getAttribute('data-url')+'?section_id='+encodeURIComponent(el.getAttribute('data-section'))+'&product_id='+pid+'&limit=10&intent='+el.getAttribute('data-intent');
    fetch(url).then(function(r){return r.ok?r.text():'';}).then(function(t){
      var d=document.createElement('div');d.innerHTML=t;
      var n=d.querySelector('[data-fxr-content]');
      if(!n||!n.querySelector('.card-wrapper'))return;
      var ex=(el.getAttribute('data-exclude')||'').split(',');
      n.querySelectorAll('li.grid__item').forEach(function(li){
        var a=li.querySelector("a[href*='/products/']");
        var m=a&&a.getAttribute('href').match(/\/products\/([^/?#]+)/);
        if(m&&ex.indexOf(m[1])>-1)li.remove();
      });
      var lis=n.querySelectorAll('li.grid__item');
      if(!lis.length)return;
      for(var i=4;i<lis.length;i++)lis[i].remove();
      el.querySelector('[data-fxr-content]').innerHTML=n.innerHTML;
      el.hidden=false;
    }).catch(function(){});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flux-cookie-banner"]) return;
  try {
    
(function(){
  var root=document.querySelector('[data-fxck]');
  if(!root)return;
  var reopen=document.querySelector('[data-fxck-reopen]');
  var prefs=root.querySelector('[data-fxck-prefs]');
  var manage=root.querySelector('[data-fxck-manage]');
  var save=root.querySelector('[data-fxck-save]');
  var LS='fx_cookie_consent';
  var boxes=root.querySelectorAll('input[data-c]');
  var api=null;
  function stored(){try{return JSON.parse(localStorage.getItem(LS)||'null');}catch(e){return null;}}
  function remember(c){try{localStorage.setItem(LS,JSON.stringify(c));}catch(e){}}
  function show(){root.hidden=false;if(reopen)reopen.hidden=true;}
  function hide(){root.hidden=true;if(reopen)reopen.hidden=false;}
  function apply(c){
    remember(c);
    if(api){api.setTrackingConsent({analytics:c.analytics,marketing:c.marketing,preferences:c.preferences,sale_of_data:false},function(){});}
    hide();
  }
  function fill(c){boxes.forEach(function(b){b.checked=!!(c&&c[b.getAttribute('data-c')]);});}
  function read(){var c={};boxes.forEach(function(b){c[b.getAttribute('data-c')]=b.checked;});return c;}
  root.querySelector('[data-fxck-accept]').addEventListener('click',function(){apply({analytics:true,marketing:true,preferences:true});});
  root.querySelector('[data-fxck-reject]').addEventListener('click',function(){apply({analytics:false,marketing:false,preferences:false});});
  manage.addEventListener('click',function(){prefs.hidden=false;save.hidden=false;manage.hidden=true;});
  save.addEventListener('click',function(){apply(read());});
  if(reopen)reopen.addEventListener('click',function(){fill(stored());prefs.hidden=false;save.hidden=false;manage.hidden=true;show();});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!root.hidden&&stored())hide();});
  function start(){
    var s=stored();
    if(s){if(reopen)reopen.hidden=false;return;}
    show();
  }
  if(window.Shopify&&window.Shopify.loadFeatures){
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(err){
      if(!err&&window.Shopify.customerPrivacy){
        api=window.Shopify.customerPrivacy;
        var s=stored();
        if(!s){show();}else{if(reopen)reopen.hidden=false;}
      }else{start();}
    });
  }else{start();}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flux-coupon"] && !Shopify.designMode) return;
  try {
    
(function(){
  var f=document.querySelector('[data-fxcp-form]');
  if(!f)return;
  var input=f.querySelector('[data-fxcp-input]'),note=f.querySelector('[data-fxcp-note]');
  var K='fx_coupon';
  try{var s=sessionStorage.getItem(K);if(s){note.textContent='Code '+s+' has been saved and will be applied at checkout. Invalid or expired codes are flagged there.';note.hidden=false;}}catch(e){}
  f.addEventListener('submit',function(e){
    e.preventDefault();
    var c=input.value.trim().replace(/\s+/g,'');
    if(!c){note.textContent='Please enter a coupon code.';note.className='fxcp__note is-err';note.hidden=false;input.focus();return;}
    try{sessionStorage.setItem(K,c.toUpperCase());}catch(err){}
    window.location.href='/discount/'+encodeURIComponent(c)+'?redirect='+encodeURIComponent('/cart');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flux-header"]) return;
  try {
    
(function(){
  var K='fx_postcode';
  var d=document.querySelector('[data-fx-loc]');
  if(d){
    var out=d.querySelector('[data-fx-pc]');
    var form=d.querySelector('[data-fx-pc-form]');
    var inp=form.querySelector('input');
    var show=function(v){out.textContent=v||'Location';};
    try{var s=localStorage.getItem(K);if(s){inp.value=s;show(s);}}catch(e){}
    form.addEventListener('submit',function(e){e.preventDefault();var v=inp.value.trim().toUpperCase();try{localStorage.setItem(K,v);}catch(e){}show(v);d.open=false;});
    document.addEventListener('click',function(e){if(d.open&&!d.contains(e.target))d.open=false;});
  }
  var b=document.querySelector('[data-fx-burger]');
  var dr=document.querySelector('[data-fx-drawer]');
  if(b&&dr){
    var setOpen=function(o){dr.classList.toggle('is-open',o);dr.setAttribute('aria-hidden',o?'false':'true');b.setAttribute('aria-expanded',o?'true':'false');document.documentElement.style.overflow=o?'hidden':'';if(o){var x=dr.querySelector('.fx-drawer__x');if(x)x.focus();}else{b.focus();}};
    b.addEventListener('click',function(){setOpen(true);});
    dr.querySelectorAll('[data-fx-close]').forEach(function(el){el.addEventListener('click',function(){setOpen(false);});});
    dr.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){setOpen(false);});});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&dr.classList.contains('is-open'))setOpen(false);});
    window.addEventListener('resize',function(){if(window.innerWidth>749&&dr.classList.contains('is-open'))setOpen(false);});
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flux-help"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('[data-fxh]');
  if(!root)return;
  var panel=root.querySelector('.fxh__panel'),fab=root.querySelector('[data-fxh-toggle]');
  function set(o){panel.hidden=!o;fab.setAttribute('aria-expanded',o?'true':'false');}
  fab.addEventListener('click',function(){set(panel.hidden);});
  root.querySelector('[data-fxh-close]').addEventListener('click',function(){set(false);fab.focus();});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!panel.hidden)set(false);});
  document.addEventListener('click',function(e){if(!panel.hidden&&!root.contains(e.target))set(false);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flux-pdp-polish"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(){
    var bar=document.querySelector('[data-fx-sticky]');
    if(!bar||bar.dataset.ready)return;
    bar.dataset.ready='1';
    var btn=bar.querySelector('.fx-sticky__btn');
    function main(){return document.querySelector('product-info .product-form__submit')||document.querySelector('.product-form__submit');}
    btn.addEventListener('click',function(){var m=main();if(!m)return;if(m.disabled){m.scrollIntoView({behavior:'smooth',block:'center'});}else{m.click();}});
    var m=main();
    if(m&&'IntersectionObserver' in window){
      new IntersectionObserver(function(e){bar.classList.toggle('is-on',!e[0].isIntersecting);},{threshold:0}).observe(m);
    }else{bar.classList.add('is-on');}
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flux-quick-add"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.ready)return;
    root.dataset.ready='1';
    var tabs=root.querySelectorAll('[data-fx-tab]');
    var panels=root.querySelectorAll('[data-fx-panel]');
    tabs.forEach(function(t){t.addEventListener('click',function(){
      var i=t.getAttribute('data-fx-tab');
      tabs.forEach(function(x){x.classList.toggle('is-on',x===t);});
      panels.forEach(function(p){p.classList.toggle('is-on',p.getAttribute('data-fx-panel')===i);});
    });});
    root.querySelectorAll('[data-fx-next]').forEach(function(b){b.addEventListener('click',function(){
      var tr=b.parentNode.querySelector('.fx-qa__track');
      tr.scrollBy({left:tr.clientWidth*0.8,behavior:'smooth'});
    });});
    root.addEventListener('click',function(e){
      var btn=e.target.closest('[data-fx-add]');
      if(!btn)return;
      e.preventDefault();
      btn.classList.add('is-busy');
      var drawer=document.querySelector('cart-drawer');
      var body={items:[{id:parseInt(btn.getAttribute('data-fx-add'),10),quantity:1}]};
      if(drawer){body.sections='cart-drawer,cart-icon-bubble';body.sections_url=window.location.pathname;}
      fetch(window.routes.cart_add_url+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
        .then(function(r){return r.json();})
        .then(function(res){
          btn.classList.remove('is-busy');
          if(res.status||res.errors){alert(res.description||res.message||'Could not add this item.');return;}
          if(drawer&&drawer.renderContents){drawer.renderContents(res);}else{window.location.href=window.routes.cart_url;}
        })
        .catch(function(){btn.classList.remove('is-busy');window.location.href=window.routes.cart_url;});
    });
  }
  document.querySelectorAll('[data-fx-qa]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flux-reels"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.ready)return;
    root.dataset.ready='1';
    var dlg=root.querySelector('[data-fx-dialog]');
    var stage=root.querySelector('[data-fx-stage]');
    function close(){stage.innerHTML='';if(dlg.open)dlg.close();}
    root.querySelectorAll('[data-fx-open]').forEach(function(b){b.addEventListener('click',function(){
      var tpl=root.querySelector('[data-fx-tpl="'+b.getAttribute('data-fx-open')+'"]');
      if(!tpl)return;
      stage.innerHTML='';
      stage.appendChild(tpl.content.cloneNode(true));
      dlg.showModal();
    });});
    root.querySelector('[data-fx-close]').addEventListener('click',close);
    dlg.addEventListener('click',function(e){if(e.target===dlg)close();});
    dlg.addEventListener('close',function(){stage.innerHTML='';});
  }
  document.querySelectorAll('[data-fx-reels]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flux-slider"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.ready)return;
    root.dataset.ready='1';
    var tr=root.querySelector('.fx-slider__track');
    var n=tr.children.length;
    var dotsEl=root.querySelector('[data-fx-dots]');
    var dots=[];
    function cur(){return Math.round(tr.scrollLeft/tr.clientWidth);}
    function go(i){i=(i+n)%n;tr.scrollTo({left:i*tr.clientWidth,behavior:'smooth'});}
    function mark(){var c=cur();dots.forEach(function(b,i){b.classList.toggle('is-on',i===c);b.setAttribute('aria-current',i===c?'true':'false');});}
    if(dotsEl){for(var i=0;i<n;i++){(function(i){var b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Go to slide '+(i+1));b.addEventListener('click',function(){go(i);});dotsEl.appendChild(b);dots.push(b);})(i);}mark();}
    var p=root.querySelector('[data-fx-prev]');var nx=root.querySelector('[data-fx-next]');
    if(p)p.addEventListener('click',function(){go(cur()-1);});
    if(nx)nx.addEventListener('click',function(){go(cur()+1);});
    tr.addEventListener('keydown',function(e){if(e.key==='ArrowLeft'){e.preventDefault();go(cur()-1);}else if(e.key==='ArrowRight'){e.preventDefault();go(cur()+1);}});
    tr.addEventListener('scroll',function(){window.requestAnimationFrame(mark);},{passive:true});
    if(root.dataset.autoplay==='true'&&n>1&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      var hover=false;
      root.addEventListener('mouseenter',function(){hover=true;});
      root.addEventListener('mouseleave',function(){hover=false;});
      root.addEventListener('focusin',function(){hover=true;});
      root.addEventListener('focusout',function(){hover=false;});
      var t=setInterval(function(){if(!document.body.contains(root)){clearInterval(t);return;}if(!hover)go(cur()+1);},parseInt(root.dataset.speed,10)||5000);
    }
  }
  document.querySelectorAll('[data-fx-slider]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flux-social-proof"]) return;
  try {
    
(function(){
  var el=document.querySelector('[data-fxp]');
  if(!el)return;
  if(/^\/(cart|checkouts|account)/.test(location.pathname))return;
  try{if(sessionStorage.getItem('fx_proof_off'))return;}catch(e){}
  var items=[];
  try{items=JSON.parse(el.getAttribute('data-items'));}catch(e){}
  var days=Number(el.getAttribute('data-days'))||7,now=Date.now();
  items=(items||[]).filter(function(i){var t=Date.parse(i.ts);return i&&i.handle&&t&&now-t>=0&&now-t<=days*86400000;});
  if(!items.length)return;
  var delay=(Number(el.getAttribute('data-delay'))||8)*1000,show=(Number(el.getAttribute('data-show'))||6)*1000,gap=(Number(el.getAttribute('data-gap'))||15)*1000,max=Number(el.getAttribute('data-max'))||3;
  var shown=0,idx=0,stopped=false;
  function ago(ts){var m=Math.max(1,Math.round((Date.now()-Date.parse(ts))/60000));if(m<60)return m+(m===1?' minute ago':' minutes ago');var h=Math.round(m/60);if(h<24)return h+(h===1?' hour ago':' hours ago');var d=Math.round(h/24);return d+(d===1?' day ago':' days ago');}
  el.querySelector('[data-fxp-close]').addEventListener('click',function(){stopped=true;el.classList.remove('is-in');try{sessionStorage.setItem('fx_proof_off','1');}catch(e){}setTimeout(function(){el.hidden=true;},400);});
  function next(){
    if(stopped||shown>=max)return;
    var it=items[idx%items.length];idx++;
    fetch('/products/'+encodeURIComponent(it.handle)+'.js').then(function(r){return r.ok?r.json():null;}).then(function(p){
      if(!p||!p.available){setTimeout(next,1000);return;}
      var img=p.featured_image?p.featured_image.replace(/(\.[a-z]+)(\?|$)/i,'_128x128$1$2'):'';
      el.querySelector('[data-fxp-img]').src=img;
      el.querySelector('[data-fxp-link]').href=p.url;
      var who=it.city?('Someone in '+it.city):'A customer';
      var q=Number(it.qty)>1?(' (x'+it.qty+')'):'';
      el.querySelector('[data-fxp-line]').textContent=who+' bought'+q;
      el.querySelector('[data-fxp-title]').textContent=p.title;
      el.querySelector('[data-fxp-time]').textContent=ago(it.ts);
      el.hidden=false;shown++;
      requestAnimationFrame(function(){el.classList.add('is-in');});
      setTimeout(function(){el.classList.remove('is-in');setTimeout(next,gap);},show);
    }).catch(function(){});
  }
  setTimeout(next,delay);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flux-welcome-popup"]) return;
  try {
    
(function(){
  var el=document.querySelector('[data-fxwp]');
  if(!el)return;
  if(/^\/(cart|checkouts|account)/.test(location.pathname))return;
  if(el.getAttribute('data-preview'))return;
  var K='fx_welcome_pop';
  function get(){try{return JSON.parse(localStorage.getItem(K)||'null');}catch(e){return null;}}
  function put(v){try{localStorage.setItem(K,JSON.stringify(v));}catch(e){}}
  var st=get();
  if(st&&(st.done||(st.until&&Date.now()<st.until)))return;
  var delay=(Number(el.getAttribute('data-delay'))||6)*1000,days=Number(el.getAttribute('data-days'))||7;
  var code=el.getAttribute('data-code')||'';
  var form=el.querySelector('form'),err=el.querySelector('[data-fxwp-err]'),btn=el.querySelector('[data-fxwp-submit]');
  var formWrap=el.querySelector('[data-fxwp-form-wrap]'),done=el.querySelector('[data-fxwp-done]');
  function open(){el.hidden=false;var i=el.querySelector('#fxwp-email');if(i)setTimeout(function(){i.focus();},300);}
  function close(){el.hidden=true;var s=get()||{};if(!s.done)put({until:Date.now()+days*86400000});}
  el.querySelectorAll('[data-fxwp-close]').forEach(function(b){b.addEventListener('click',close);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!el.hidden)close();});
  function showErr(m){err.textContent=m;err.hidden=false;}
  form.addEventListener('submit',function(e){
    e.preventDefault();err.hidden=true;
    var email=form.querySelector('input[type=email]').value.trim();
    if(!/^\S+@\S+\.\S+$/.test(email)){showErr('Please enter a valid email address.');return;}
    if(!form.querySelector('[data-fxwp-consent]').checked){showErr('Please tick the box to agree to receive emails.');return;}
    btn.disabled=true;
    fetch(form.action,{method:'POST',body:new FormData(form),credentials:'same-origin'}).then(function(r){
      if(!r.ok&&r.status!==200)throw 0;
      return r.text().then(function(t){
        if(/customer_posted=true/.test(r.url)||r.ok){
          if(/class="[^"]*errors/.test(t)&&!/customer_posted=true/.test(r.url)){throw 0;}
          put({done:true,code:code});
          formWrap.hidden=true;done.hidden=false;
          el.querySelector('[data-fxwp-code]').textContent=code;
          el.querySelector('[data-fxwp-apply]').href='/discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(el.getAttribute('data-shop')||'/');
        }else{throw 0;}
      });
    }).catch(function(){btn.disabled=false;showErr('Sorry, something went wrong. Please try again.');});
  });
  el.querySelector('[data-fxwp-copy]').addEventListener('click',function(){
    var b=this;
    if(navigator.clipboard){navigator.clipboard.writeText(code).then(function(){b.textContent='Copied';});}
  });
  function start(){setTimeout(open,delay);}
  function waitCookie(){
    var tries=0;
    (function chk(){
      var decided=false;try{decided=!!localStorage.getItem('fx_cookie_consent');}catch(e){decided=true;}
      if(decided||tries>60){start();return;}
      tries++;setTimeout(chk,1000);
    })();
  }
  waitCookie();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flux-wishlist-hearts"]) return;
  try {
    
(function(){
  var holder=document.querySelector('[data-fx-wl-user]');
  if(!holder)return;
  var uid=holder.getAttribute('data-fx-wl-user');
  var loginUrl=holder.getAttribute('data-fx-login')||'/account/login';
  var KEY='fx_wl_'+uid;
  var P='M12 20.5s-7.5-4.6-9-9.3C2 8 4 5.5 6.8 5.5c1.9 0 3.5 1 5.2 3 1.7-2 3.3-3 5.2-3C20 5.5 22 8 21 11.2c-1.5 4.7-9 9.3-9 9.3z';
  var SVG="<svg viewBox='0 0 24 24' aria-hidden='true'><path d='"+P+"'/></svg>";
  function get(){try{return JSON.parse(localStorage.getItem(KEY)||'[]');}catch(e){return [];}}
  function set(a){try{localStorage.setItem(KEY,JSON.stringify(a));}catch(e){}document.dispatchEvent(new CustomEvent('fx:wishlist'));}
  function handleOf(href){var m=(href||'').match(/\/products\/([^/?#]+)/);return m?m[1]:null;}
  function toggle(h){
    if(!uid){window.location.href=loginUrl+(loginUrl.indexOf('?')>-1?'&':'?')+'return_url='+encodeURIComponent('/pages/wishlist');return;}
    var a=get(),i=a.indexOf(h);
    if(i>-1)a.splice(i,1);else a.push(h);
    set(a);
  }
  function refresh(){
    var a=get();
    document.querySelectorAll('[data-fx-h]').forEach(function(b){
      var on=uid&&a.indexOf(b.getAttribute('data-fx-h'))>-1;
      b.classList.toggle('is-on',!!on);
      b.setAttribute('aria-pressed',on?'true':'false');
      if(b.classList.contains('fx-heart-pdp')){b.querySelector('span').textContent=on?'Saved to wishlist':'Add to wishlist';}
    });
  }
  function inject(){
    document.querySelectorAll('.card-wrapper').forEach(function(c){
      if(c.querySelector('.fx-heart'))return;
      var l=c.querySelector("a[href*='/products/']");var h=l&&handleOf(l.getAttribute('href'));
      if(!h)return;
      var b=document.createElement('button');b.type='button';b.className='fx-heart';b.setAttribute('data-fx-h',h);b.setAttribute('aria-label','Add to wishlist');b.innerHTML=SVG;
      b.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();toggle(h);});
      c.appendChild(b);
    });
    var ph=handleOf(location.pathname);
    if(ph&&/\/products\//.test(location.pathname)&&!document.querySelector('.fx-heart-pdp')){
      var t=document.querySelector('.product__title');
      if(t){var b2=document.createElement('button');b2.type='button';b2.className='fx-heart-pdp';b2.setAttribute('data-fx-h',ph);b2.innerHTML=SVG+'<span>Add to wishlist</span>';b2.addEventListener('click',function(){toggle(ph);});t.insertAdjacentElement('afterend',b2);}
    }
    refresh();
  }
  var timer;
  new MutationObserver(function(){clearTimeout(timer);timer=setTimeout(inject,150);}).observe(document.body,{childList:true,subtree:true});
  document.addEventListener('fx:wishlist',refresh);
  inject();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flux-wishlist"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('[data-fx-wishlist]');
  if(!root)return;
  var uid=root.getAttribute('data-user');
  if(!uid)return;
  var KEY='fx_wl_'+uid;
  var grid=root.querySelector('[data-fxw-grid]'),state=root.querySelector('[data-fxw-state]'),empty=root.querySelector('[data-fxw-empty]');
  function get(){try{return JSON.parse(localStorage.getItem(KEY)||'[]');}catch(e){return [];}}
  function put(a){try{localStorage.setItem(KEY,JSON.stringify(a));}catch(e){}}
  function money(c){return new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format(c/100);}
  function esc(s){var d=document.createElement('div');d.textContent=s==null?'':s;return d.innerHTML;}
  function card(p){
    var img=p.featured_image?p.featured_image.replace(/(\.[a-z]+)(\?|$)/i,'_500x$1$2'):'';
    var single=p.variants&&p.variants.length===1&&p.available;
    var action=single?"<button type='button' class='fxw__btn' data-add='"+p.variants[0].id+"'>Add to cart</button>":"<a class='fxw__btn' href='"+esc(p.url)+"'>"+(p.available?'Choose options':'View')+"</a>";
    var el=document.createElement('div');el.className='fxw__card';el.setAttribute('data-h',p.handle);
    el.innerHTML="<a class='fxw__img' href='"+esc(p.url)+"'>"+(img?"<img src='"+esc(img)+"' alt='"+esc(p.title)+"' loading='lazy'>":'')+"</a><div class='fxw__body'><span class='fxw__vendor'>"+esc(p.vendor)+"</span><a class='fxw__title' href='"+esc(p.url)+"'>"+esc(p.title)+"</a><span class='fxw__price'>"+money(p.price)+"</span><div class='fxw__row'>"+action+"<button type='button' class='fxw__rm' data-rm='"+esc(p.handle)+"' aria-label='Remove from wishlist'>&times;</button></div></div>";
    return el;
  }
  function checkEmpty(){empty.hidden=grid.children.length>0;}
  root.addEventListener('click',function(e){
    var rm=e.target.closest('[data-rm]');
    if(rm){var h=rm.getAttribute('data-rm');put(get().filter(function(x){return x!==h;}));var c=rm.closest('.fxw__card');if(c)c.remove();checkEmpty();return;}
    var add=e.target.closest('[data-add]');
    if(add){add.disabled=true;add.textContent='Adding...';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(add.getAttribute('data-add')),quantity:1}]})}).then(function(r){if(!r.ok)throw 0;window.location.href='/cart';}).catch(function(){add.disabled=false;add.textContent='Try again';});}
  });
  var list=get();
  if(!list.length){state.hidden=true;checkEmpty();return;}
  Promise.all(list.map(function(h){return fetch('/products/'+h+'.js').then(function(r){return r.ok?r.json():null;}).catch(function(){return null;});})).then(function(ps){
    state.hidden=true;
    ps.forEach(function(p){if(p)grid.appendChild(card(p));});
    checkEmpty();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
